<template>
    <v-container fluid class="full-screen">
      <v-btn 
        color="red" 
        class="close-button"
        @click="voltar"
      >
        Voltar
      </v-btn>
      <iframe 
        class="bi-frame"
        src="https://im-a-puzzle.com/share/0e2322769c011c2?embed=true&showAds=false&showNav=false&showSolve=false"         
        frameborder="0"
        allowfullscreen 
        sandbox="allow-storage-access-by-user-activation allow-scripts allow-same-origin allow-popups allow-popups-to-escape-sandbox">
      </iframe>
    </v-container>
  </template>
  <script>
  export default {
  data() {    
  },
  methods: {
    voltar() {
      if (window.history.length > 1) {
        window.history.back();
      } else {
        this.$emit('fecharRelatorio');
      }
    },
  } 
}
</script>
  <style scoped>
  .full-screen {
    height: 100vh;
    width: 100vw;
    margin: 0;
    padding: 0;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    background-color: black;
  }
  
  .bi-frame {
  width: 100%;
  height: 900px;
  border: none;
  overflow: hidden; /* Esconde barras de rolagem */
  transform: scale(1.1); /* Aplica zoom de 110% */
  transform-origin: bottom center; /* Alinha o zoom pela base */
}


  
  .close-button {
    position: absolute;
    top: 20px;
    left: 20px;
    z-index: 100;
  }
  </style>
  